export function attendeeDisplayName(nickname: string | null | undefined, oderId: string): string {
  return nickname || `Anon-${oderId.slice(-5)}`;
}
